import { useReducer, createContext, useContext, useEffect } from "react";

import { useTeleSwapApi } from "services/useTeleSwapApi";

import {
    dexList,
    exchangeTokenOptions,
    firstNetwork,
    isTestnet,
    slippageList,
    speedTypeList,
    swapSpeedList,
} from "utils/configs";

const initialState = {
    bridgeForm: {
        inputAddress: undefined,
        inputAmount: isTestnet ? "1" : "1000",
        inputBalance: null,
        // inputToken: undefined,
        inputToken: isTestnet
            ? exchangeTokenOptions?.[firstNetwork]?.find(
                  (i: any) => i?.value?.type?.includes("ton") && i.value.symbol.includes("TON"),
              )?.value
            : exchangeTokenOptions?.[firstNetwork]?.find(
                  (i: any) => i?.value?.type?.includes("evm") && i.value.symbol.includes("USDC"),
              )?.value,

        // inputNetwork: undefined,
        inputNetwork: firstNetwork,
        outputAddress: undefined,
        referralAddress: undefined,
        outputAmount: undefined,
        outputBalance: null,
        outputToken: exchangeTokenOptions?.[firstNetwork]?.filter(
            (i: any) => !(i?.value?.type?.includes("evm") || i.value.type.includes("ton")),
        )[0].value,
        // outputToken: undefined,
        outputNetwork: "Bitcoin",

        selectedDex: dexList[0].value,
        speedType: isTestnet ? speedTypeList[2].key : speedTypeList[2].key,
        swapSpeed: isTestnet ? swapSpeedList[0].key : swapSpeedList[0].key,
        slippage: slippageList[2].value,
        confirmations: 20,

        isFixedOutputToken: false,
        isReverseSwapRate: false,
    },
};

const FormStateContext = createContext(initialState as any);
const FormDispatchContext = createContext((() => 0) as React.Dispatch<any>);

const formReducer = (state: any, action: any) => {
    let _window: any = null;
    _window = typeof window === "undefined" ? null : window;

    switch (action.type) {
        case "setBridgeForm":
            return { ...state, bridgeForm: action.value };

        default:
            throw new Error(`Unexpected action: ${action.type}`);
    }
};

const FormProvider = (props: any) => {
    const location = window.location;
    const { getSupportedPairsExchange } = useTeleSwapApi();
    const params = new URLSearchParams(location?.search);
    const pathname = window?.location?.pathname;

    const inputNetwork = params.get("fromBlockchain") || initialState.bridgeForm.inputNetwork;
    const isWrap = inputNetwork === "Bitcoin";
    const _inputToken = params.get("fromToken");

    const outputNetwork = params.get("toBlockchain") || initialState.bridgeForm.outputNetwork;
    const _outputToken = params.get("toToken");

    const inputToken =
        exchangeTokenOptions?.[isWrap ? outputNetwork : inputNetwork]?.find((i: any) => i.value.symbol === _inputToken)
            ?.value || initialState.bridgeForm.inputToken;

    const outputToken =
        exchangeTokenOptions?.[isWrap ? outputNetwork : inputNetwork]?.find((i: any) => i.value.symbol === _outputToken)
            ?.value || initialState.bridgeForm.outputToken;

    const fromAmount = params.get("fromAmount");
    const inputAmount = fromAmount ? fromAmount : initialState.bridgeForm.inputAmount;

    const [formState, DispatchFormState] = useReducer(formReducer, {
        ...initialState,
        bridgeForm: {
            ...initialState.bridgeForm,
            inputNetwork,
            inputToken,
            outputNetwork,
            outputToken,
            inputAmount,
        },
    });

    useEffect(() => {
        if (pathname.includes("/bridge/")) {
            const _pathname = pathname.split("/")[2];
            const _pathnames = _pathname.split("-");
            const inputToken_ = _pathnames[0];
            const outputToken_ = _pathnames[2];

            const __inputNetwork = inputToken_ === "btc" || inputToken_ === "dog" ? "Bitcoin" : "Ethereum";
            const __outputNetwork = inputToken_ === "btc" || inputToken_ === "dog" ? "Ethereum" : "Bitcoin";

            const _inputAmount =
                inputToken_ === "btc" || inputToken_ === "wbtc"
                    ? "0.01"
                    : inputToken_ === "dog"
                      ? "1000"
                      : inputToken_ === "eth"
                        ? "1"
                        : "1000";
            const _isWrap = __inputNetwork === "Bitcoin";
            getSupportedPairsExchange().then((res) => {
                const ــinputToken = res.tokenOptions?.[_isWrap ? __outputNetwork : __inputNetwork]?.find(
                    (i: any) => i.value.symbol.toLowerCase() === inputToken_.toLowerCase(),
                )?.value;

                const ــoutputToken = res.tokenOptions?.[_isWrap ? __outputNetwork : __inputNetwork]?.find(
                    (i: any) => i.value.symbol.toLowerCase() === outputToken_.toLowerCase(),
                )?.value;
                debugger;
                DispatchFormState({
                    type: "setBridgeForm",
                    value: {
                        ...formState.bridgeForm,
                        inputNetwork: __inputNetwork,
                        inputToken: ــinputToken,
                        outputNetwork: __outputNetwork,
                        outputToken: ــoutputToken,
                        inputAmount: _inputAmount,
                    },
                });
            });
        } else if (params.get("fromBlockchain")) {
            getSupportedPairsExchange().then((res) => {
                const ــinputToken =
                    res.tokenOptions?.[isWrap ? outputNetwork : inputNetwork]?.find(
                        (i: any) => i.value.symbol === _inputToken,
                    )?.value || initialState.bridgeForm.inputToken;

                const ــoutputToken =
                    res.tokenOptions?.[isWrap ? outputNetwork : inputNetwork]?.find(
                        (i: any) => i.value.symbol === _outputToken,
                    )?.value || initialState.bridgeForm.outputToken;

                DispatchFormState({
                    type: "setBridgeForm",
                    value: {
                        ...formState.bridgeForm,
                        inputNetwork,
                        inputToken: ــinputToken,
                        outputNetwork,
                        outputToken: ــoutputToken,
                        inputAmount,
                    },
                });
            });
        }
    }, []);

    return (
        <FormStateContext.Provider value={formState}>
            <FormDispatchContext.Provider value={DispatchFormState}>{props.children}</FormDispatchContext.Provider>
        </FormStateContext.Provider>
    );
};

const useFormState = () => {
    const context = useContext(FormStateContext);
    if (context === undefined) {
        throw new Error("useFormState must be used within a FormProvider");
    }
    return context;
};

const useFormDispatch = () => {
    const context = useContext(FormDispatchContext);
    if (context === undefined) {
        throw new Error("useFormDispatch must be used within a FormProvider");
    }
    return context;
};

export { FormProvider, useFormState, useFormDispatch };
